export const SimpleQueue = () => {
    /**
     * @type {Promise<unknown> | undefined}
     */
    let tail;
    /**
     * @template T
     * @param {() => Promise<T>} callback
     * @returns {Promise<T>}
     */
    const queue = (callback) => {
        const result = (tail ? tail.then(callback, callback) : callback()).finally(() => {
            if (tail === result) {
                tail = undefined;
            }
        });
        tail = result;
        return result;
    };
    return queue;
};
